export default __webpack_public_path__ + "static/media/twoFALoginScreen.8e72265c.png";